import { FC, Fragment } from 'react'
import { Box } from '@mui/material'
import createStyles from '@mui/styles/createStyles'
import { ToggleSwitch } from 'packages/eid-ui'
import { useTranslation } from 'react-i18next'
import { StartDateControl } from './StartDateControl'
import { EndDateControl } from './EndDateControl'
import makeStyles from '@mui/styles/makeStyles'

export interface TimeConstrainedControlProps {
    selectedStartDate: any
    setSelectedStartDate: any
    selectedEndDate: any
    setSelectedEndDate: any
    isEndDateDisabled?: any
    maxEndDate?: any
    hasInvalidDates: any
    validationMessage: any
    toggle?: boolean
    setToggle?: any
    disabled: boolean
    hideSwitch: boolean
    hideStartDate?: boolean
}

const useStyles = makeStyles((theme) =>
    createStyles({
        applicationStartDatePickerContainer: {
            width: '157px',
            marginBottom: '25px',

            '@media (max-width:959px)': {
                width: '100%',
                marginLeft: '0px',
                paddingTop: '8px',
                paddingBottom: '8px',
            },
        },
        startDatePickerContainer: {
            marginLeft: '16px',
            width: '157px',

            '@media (max-width:959px)': {
                width: '100%',
                marginLeft: '0px',
                paddingTop: '8px',
                paddingBottom: '8px',
            },
        },
        applicationEndDatePickerContainer: {
            width: '157px',

            '@media (max-width:959px)': {
                width: '100%',
                marginLeft: '0px',
                paddingTop: '8px',
                paddingBottom: '8px',
            },
        },
        endDatePickerContainer: {
            marginLeft: '24px',
            width: '157px',

            '@media (max-width:959px)': {
                width: '100%',
                marginLeft: '0px',
                paddingTop: '8px',
                paddingBottom: '8px',
            },
        },
        policyViolationMessage: {
            position: 'absolute',
            fontSize: '12px',
            color: theme?.palette?.error?.main,
            marginRight: '12px',
            whiteSpace: 'nowrap',
        },
        defaultPicker: {
            display: 'flex',
        },
    }),
)

export const TimeConstrainedControl: FC<TimeConstrainedControlProps> = ({
    selectedStartDate,
    setSelectedStartDate,
    selectedEndDate,
    setSelectedEndDate,
    isEndDateDisabled,
    maxEndDate,
    hasInvalidDates,
    validationMessage,
    toggle,
    disabled,
    setToggle,
    hideSwitch,
    hideStartDate = false,
}) => {
    const { t } = useTranslation()
    const classes = useStyles()

    return (
        <>
            {!hideSwitch && (
                <Box>
                    <ToggleSwitch
                        value={toggle}
                        label={t('Common_SetDuration')}
                        labelColor="#5d6870"
                        disabled={disabled}
                        onChange={() => setToggle((prev: any) => !prev)}
                    />
                </Box>
            )}

            {toggle && (
                <Box className={classes.defaultPicker}>
                    <Fragment>
                        {!hideStartDate && (
                            <Box className={classes.startDatePickerContainer}>
                                <StartDateControl
                                    selectedStartDate={selectedStartDate}
                                    setSelectedStartDate={setSelectedStartDate}
                                    disabled={disabled}
                                />
                            </Box>
                        )}
                        <Box className={classes.endDatePickerContainer}>
                            <EndDateControl
                                selectedStartDate={selectedStartDate}
                                selectedEndDate={selectedEndDate}
                                setSelectedEndDate={setSelectedEndDate}
                                maxEndDate={maxEndDate}
                                hasInvalidDates={hasInvalidDates}
                                disabled={disabled || isEndDateDisabled}
                            />
                            {hasInvalidDates && validationMessage && (
                                <Box className={classes.policyViolationMessage}>
                                    {validationMessage}
                                </Box>
                            )}
                        </Box>
                    </Fragment>
                </Box>
            )}
        </>
    )
}
